import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const FALLBACK = "https://images.pexels.com/photos/5998480/pexels-photo-5998480.jpeg";

export default function InterviewCard({ interview, index = 0 }) {
  const img = interview.profile_image || FALLBACK;
  return (
    <Link
      to={`/interviews/${interview.id}`}
      className="group block border border-rule bg-white hover:border-navy transition-colors duration-300"
      data-testid={`interview-card-${interview.id}`}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-parchment">
        <img
          src={img}
          alt={interview.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
        />
        <div className="absolute top-4 left-4 bg-white/95 px-3 py-1 text-[10px] uppercase tracking-[0.2em] text-navy">
          {interview.category}
        </div>
      </div>
      <div className="p-6 lg:p-7">
        <div className="text-[10px] uppercase tracking-[0.2em] text-medblue">
          {interview.profession}
        </div>
        <h3 className="mt-2 font-serif text-2xl leading-tight text-navy">
          {interview.name}
        </h3>
        <div className="mt-1 text-sm text-navy/60">
          {interview.specialty}
          {interview.organization ? ` · ${interview.organization}` : ""}
        </div>
        {interview.chapters && interview.chapters.length > 0 ? (
          <div className="mt-5 pt-4 border-t border-rule">
            <div className="text-[9px] uppercase tracking-[0.24em] text-navy/50 mb-2.5">In this conversation</div>
            <ul className="space-y-1.5">
              {interview.chapters.slice(0, 3).map((c, i) => (
                <li key={i} className="flex items-baseline gap-2.5 text-sm text-navy/75">
                  <span className="font-mono text-[10px] text-medblue shrink-0">{String(i + 1).padStart(2, "0")}</span>
                  <span className="leading-snug line-clamp-1">{c}</span>
                </li>
              ))}
              {interview.chapters.length > 3 && (
                <li className="text-[10px] uppercase tracking-[0.2em] text-navy/40 pl-6">
                  + {interview.chapters.length - 3} more
                </li>
              )}
            </ul>
          </div>
        ) : interview.excerpt ? (
          <p className="mt-4 text-sm text-navy/70 leading-relaxed line-clamp-3">
            {interview.excerpt}
          </p>
        ) : null}
        <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-navy group-hover:text-medblue transition-colors">
          Read interview <ArrowUpRight size={14} />
        </div>
      </div>
    </Link>
  );
}
